import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {DashboardService} from '../../../core/service/dashboard.service';
import {AuthenticationService} from '../../../core/service';
import {User} from '../../../core/models';
import {SubdomainInfo} from 'app/core/models/subdomain-info';
import {PricingPlan} from '../../../core/helpers/constants';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'benefit-header-summary',
  templateUrl: './benefit-header-summary.component.html',
  styleUrls: ['./benefit-header-summary.component.scss'],
})
export class BenefitHeaderSummaryComponent implements OnInit, OnDestroy {

  @Input() headerText?: string;
  @Input() subheaderText?: string;
  @Input() smallText?: string;
  @Input() bigText?: string;
  @Input() showBudgetCard = true;
  @Input() offeredBy: string;
  @Input() headerType: 'full' | 'title-only' | 'card-only' = 'full';

  private ngUnsubscribe = new Subject<void>();
  public userDashboardInfo: User;
  public totalAmountBalance: number;
  public pendingCashbackAmount = 0;
  public displayBudgets: boolean;
  userCompanyInfo: SubdomainInfo;
  screenWidth: number;

  constructor(
    private dashboardService: DashboardService,
    private authService: AuthenticationService) {
    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(_event?) {
    this.screenWidth = window.innerWidth;
  }

  ngOnInit() {
    this.authService.currentUserInfo.subscribe(x => {
      this.userDashboardInfo = x;
      this.getTotalAmount();
    });
    this.authService.currentUserCompanyInfo.subscribe((companyInfo) => {
      this.userCompanyInfo = companyInfo;
      this.getTotalAmount();

      if (companyInfo.hasCashbackBudget) {
        this.dashboardService
          .getPendingCashback()
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: value => {
              this.pendingCashbackAmount = value;
            },
            error: err => {}
          });
      }
    });
    // eslint-disable-next-line max-len
    this.displayBudgets = this.userCompanyInfo.pricingPlan === PricingPlan.FLEX && (this.userCompanyInfo.hasTransportBudget || this.userCompanyInfo.hasProfessionalDevelopmentBudget || this.userCompanyInfo?.hasCashbackBudget);
  }

  getTotalAmount() {
    this.totalAmountBalance = this.userDashboardInfo.totalAmount;
    if (this.userCompanyInfo?.hasTransportBudget) {
      this.totalAmountBalance += this.userDashboardInfo.totalAmountTransport;
    }
    if (this.userCompanyInfo?.hasProfessionalDevelopmentBudget) {
      this.totalAmountBalance += this.userDashboardInfo.totalAmountProfessionalDevelopment;
    }

    if (this.userCompanyInfo?.hasCashbackBudget && this.userDashboardInfo?.totalAmountCashback !== null) {
      this.totalAmountBalance += this.userDashboardInfo.totalAmountCashback;
    }
    this.bigText = this.totalAmountBalance.toFixed(2) + ' RON';
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  protected readonly PricingPlan = PricingPlan;
}
